import React, { useEffect, Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Hero from './components/Hero';
import ServicesBar from './components/ServicesBar';
import Intro from './components/Intro';
import Services from './components/Services';
import HowItWorks from './components/HowItWorks';
import Psychology from './components/Psychology';
import Traslochi from './components/Traslochi';
import WhyChooseUs from './components/WhyChooseUs';
import Statement from './components/Statement';
import BeforeAfter from './components/BeforeAfter';
import Features from './components/Features';
import Reviews from './components/Reviews';
import FAQ from './components/FAQ';
import FinalCTA from './components/FinalCTA';
import MobileStickyBar from './components/MobileStickyBar';
import Footer from './components/Footer';
import CookieBanner from './components/CookieBanner';
import LegalPage from './pages/LegalPage';
import NotFound from './pages/NotFound';

const ServiceMap = lazy(() => import('./components/ServiceMap'));

function ScrollToTop() {
  const { pathname } = useLocation();
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  
  return null;
}

function HomePage() {
  return (
    <>
      <Hero />
      <ServicesBar />
      <Intro />
      <Services />
      <HowItWorks />
      <Psychology />
      <Traslochi />
      <WhyChooseUs />
      <Statement />
      <BeforeAfter />
      <Features />
      <Suspense fallback={<div className="h-[500px] bg-maaich-black animate-pulse flex items-center justify-center text-white/20 font-display italic">Caricamento Mappa...</div>}>
        <ServiceMap />
      </Suspense>
      <Reviews />
      <FAQ />
      <FinalCTA />
    </>
  );
}

function App() {
  useEffect(() => {
    document.documentElement.style.scrollBehavior = 'smooth';
  }, []);

  return (
    <Router>
      <ScrollToTop />
      <div className="relative min-h-screen bg-maaich-black overflow-x-hidden">
        <div className="grain-overlay pointer-events-none"></div>
        
        <main className="relative z-10">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/privacy-policy" element={
              <LegalPage title="Informativa Privacy">
                <p>Ai sensi del Regolamento (UE) 2016/679 ("GDPR") e del D.Lgs. 196/2003 come modificato dal D.Lgs. 101/2018.</p>
                <p>Ultimo aggiornamento: Luglio 2026.</p>

                <h2>1. Titolare del trattamento</h2>
                <p>Il titolare del trattamento dei dati è MAAICH Sgomberi, Limbiate (MB).</p>
                <p>Contatti: WhatsApp 392 103 7894 · Tel. 351 648 8306.</p>

                <h2>2. Tipologie di dati trattati</h2>
                <p><strong>a) Dati di navigazione.</strong> I sistemi informatici acquisiscono dati la cui trasmissione è implicita nell'uso di Internet: indirizzi IP, orario della richiesta, browser utilizzato. Questi dati garantiscono il corretto funzionamento del sito.</p>
                <p><strong>b) Dati forniti volontariamente.</strong> Se l'utente ci contatta tramite WhatsApp o telefono, i dati (numero, nome, contenuto del messaggio) vengono trattati esclusivamente per rispondere alla richiesta e formulare il preventivo.</p>
                <p><strong>c) Cookie.</strong> Si veda la Cookie Policy.</p>

                <h2>3. Finalità e basi giuridiche</h2>
                <ul>
                  <li>Funzionamento tecnico → legittimo interesse.</li>
                  <li>Richieste di preventivo → esecuzione di misure precontrattuali.</li>
                  <li>Statistiche (GA4) → consenso tramite banner cookie.</li>
                </ul>

                <h2>4. Strumenti di terze parti</h2>
                <ul>
                  <li>Mappa OpenStreetMap (tile server)</li>
                  <li>Google Analytics 4 (statistiche aggregate)</li>
                  <li>Google Ads (misurazione conversioni)</li>
                </ul>

                <h2>5. Diritti dell'interessato</h2>
                <p>L'utente ha diritto di accesso, rettifica, cancellazione e opposizione. Le richieste possono essere inviate ai contatti indicati al punto 1.</p>
              </LegalPage>
            } />
            <Route path="/cookie-policy" element={
              <LegalPage title="Cookie Policy">
                <p>Ultimo aggiornamento: Luglio 2026.</p>

                <h2>1. Cosa sono i cookie</h2>
                <p>I cookie sono piccoli file di testo che i siti inviano al dispositivo dell'utente per essere ritrasmessi alla visita successiva.</p>

                <h2>2. Cookie utilizzati</h2>
                <p><strong>a) Tecnici:</strong> memorizzano la scelta del consenso. Durata: 6 mesi.</p>
                <p><strong>b) Misurazione (previo consenso):</strong> Google Analytics 4 (_ga) per statistiche aggregate. Durata fino a 24 mesi.</p>
                <p><strong>c) Marketing (previo consenso):</strong> Google Ads (_gcl) per conversioni pubblicitarie. Durata 90 giorni.</p>

                <h2>3. Gestione del consenso</h2>
                <p>Puoi modificare le tue scelte in ogni momento tramite il link "Gestisci cookie" nel footer o cancellando la cache del browser.</p>
              </LegalPage>
            } />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>

        <Footer />
        <MobileStickyBar />
        <CookieBanner />
      </div>
    </Router>
  );
}

export default App;